module.exports = {"621224100":"城关镇","621224101":"平洛镇","621224102":"大堡镇","621224103":"岸门口镇","621224104":"两河镇","621224105":"长坝镇","621224106":"云台镇","621224107":"阳坝镇","621224108":"王坝镇","621224109":"碾坝镇","621224110":"豆坝镇","621224111":"望关镇","621224112":"大南峪镇","621224113":"周家坝镇","621224114":"寺台镇","621224115":"白杨镇","621224116":"铜钱镇","621224117":"三河坝镇","621224204":"迷坝乡","621224209":"店子乡","621224214":"太石乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/621224.json
// module id = 3097
// module chunks = 0